import React, { useState } from 'react';
import MethodSelector from './MethodSelector';
import DetailLevelSelector from './DetailLevelSelector';
import FormDynamicRenderer from './FormDynamicRenderer';
import PDFPreview from './PDFPreview';
import MethodInfoModal from './MethodInfoModal';
import { methods } from './data/methodsMetadata';
import styles from './Guide.module.css';

const CreateProject = () => {
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [detailLevel, setDetailLevel] = useState(null);
  const [formData, setFormData] = useState({});
  const [showInfo, setShowInfo] = useState(null);

  const handleMethodSelect = (methodId) => {
    setSelectedMethod(methodId);
    setDetailLevel(null); // Reset level if method changes
    setFormData({});
  };

  const handleDetailLevelSelect = (level) => {
    setDetailLevel(level);
  };

  const handleFormDataChange = (data) => {
    setFormData(data);
  };

  const handleShowInfo = (methodId) => {
    setShowInfo(methodId);
  };

  const handleCloseInfo = () => {
    setShowInfo(null);
  };

  return (
    <div className={styles['create-project-container']}>
      <h1>Créer un projet</h1>
      <p>Sélectionne une méthode pour organiser ton projet.</p>

      {!selectedMethod && (
        <MethodSelector onSelect={handleMethodSelect} onInfo={handleShowInfo} />
      )}

      {selectedMethod && !detailLevel && (
        <DetailLevelSelector onSelect={handleDetailLevelSelect} />
      )}

      {selectedMethod && detailLevel && (
        <FormDynamicRenderer
          methodId={selectedMethod}
          detailLevel={detailLevel}
          formData={formData}
          onFormDataChange={handleFormDataChange}
        />
      )}

      {selectedMethod && detailLevel && (
        <PDFPreview formData={formData} methodId={selectedMethod} detailLevel={detailLevel} />
      )}

      {showInfo && (
        <MethodInfoModal
          methodId={showInfo}
          onClose={handleCloseInfo}
          method={methods.find((m) => m.id === showInfo)}
        />
      )}
    </div>
  );
};

export default CreateProject;
